import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from '@/locales/index';
import plugins from './plugins/index'; // plugins
import { createHead } from '@unhead/vue';
import vue3GoogleLogin from 'vue3-google-login';
import { useSettingsStore } from '@/store/modules/setting';
import cache from '@/utils/cache';
import './assets/css/global.scss';
import './assets/css/layout.scss';
import './assets/css/theme.scss';
import './assets/css/icon.scss';
import 'virtual:uno.css';
import('element-plus/theme-chalk/el-message-box.css');
import('element-plus/theme-chalk/display.css');
// import * as Sentry from '@sentry/vue';
// import 'element-plus/theme-chalk/display.css';
// import 'element-plus/theme-chalk/el-message-box.css';
// import 'nprogress/nprogress.css';

const app = createApp(App);

// 根据环境选择 DSN
// const getSentryDSN = () => {
//   const env = import.meta.env.VITE_APP_ENV;
//   switch (env) {
//     case 'development':
//       return import.meta.env.VITE_SENTRY_DSN_DEV;
//     case 'production':
//       return import.meta.env.VITE_SENTRY_DSN_PROD;
//     default:
//       return import.meta.env.VITE_SENTRY_DSN;
//   }
// };

// Sentry.init({
//   app,
//   dsn: getSentryDSN(),
//   integrations: [Sentry.browserTracingIntegration()],
//   tracesSampleRate: 1.0,
//   sendDefaultPii: true
// });

// Sentry.logger.info('User triggered test log', { log_source: 'sentry_test' });

const head = createHead();
const { queueIdleTask } = useIdleQueueTask();
// 全局方法
queueIdleTask(() => {
  app
    .use(head)
    .use(plugins)
    .use(store)
    .use(i18n)
    .use(router)
    .use(vue3GoogleLogin, {
      clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID
    })
    .mount('#app');
});

queueIdleTask(() => {
  const { initDevice, initRatio, addTheme } = useSettingsStore();
  initDevice(); // 设备区分
  initRatio(); // 分辨率区分
  const isDark = usePreferredDark();
  const defalut = cache.local.get(VITE_THEME);
  let defaultTheme = defalut || '';
  if (isDark.value && defalut === 'auto') {
    defaultTheme = 'dark';
  }
  addTheme(defaultTheme); //初始化 主题
});
